import React, { useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import {
  resetCognitoSubUser
} from "Redux/actions";
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { Button, Form, Input } from "@gpstrackit/gtc-react-controls";
import { Grid } from '@mui/material';

const ResetEmail = (props) => {
  const { showResetEmail, onClose, subUserInfo } = props
  const { messages } = useIntl();
  const dispatch = useDispatch();
  const { loadingSubUser, loading } = useSelector(state => state.subUserRedux);
  
  //Ref
  const formRef = useRef();
  
  const [errorMessage, setErrorMessage] = useState();
  const [formData, setFormData] = useState({});

  const isValidEmail = () => {
    if(formData?.email == formData.cloneEmail){
      return false
    }
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(formData?.email);
  }
  
  useEffect(() => {

    if (subUserInfo) {
      let item = subUserInfo
      if(Array.isArray(subUserInfo)){
        item = subUserInfo[0]
      }
      setFormData({
        ...formData,
        email: item.email,
        id: item.id,
        cloneEmail: item.email

      })
    }
  }, [subUserInfo])

  const submit = () => {
    if(isValidEmail()){
      dispatch(resetCognitoSubUser({ id: formData?.id, email: formData?.email }));
      setErrorMessage("")
    } else {
      setErrorMessage(messages["required_email"])
    }
    
  }

  return (
    <Modal
      title={messages["subUser_resetEmail"]}
      open={showResetEmail}
      size="small"
      handleClose={() => onClose()}
      position="right"
      loading={loadingSubUser}
      style={{ overflow: 'hidden' }}
      className="overflow-hidden"
    >
      <ModalBody
        style={{
          overflow: 'hidden',
          marginBottom: 0
        }}
      >
        <div
          style={{
            padding: "0px 24px 24px 24px",
            height: "calc(100vh - 202px)",
            overflow: "auto"
          }}
        >
          <Form
            ref={formRef}
            onValidSubmit={() => submit()}
          >
            <Grid
              container
              justifyContent={'center'}
              direction={'column'}
              spacing={2}
            >
              <Grid
                container
                item
                spacing={1}
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-start"
                style={{marginTop: "10px"}}
              >
                <Grid item xs>
                  {
                    errorMessage &&
                    <small className="select-error text-danger">{errorMessage}</small>
                  }
                  <Input
                    id="email"
                    type="email"
                    label={messages['email']}
                    placeholder={messages['email']}
                    value={formData?.email || ""}
                    onChange={(value) =>
                      setFormData({
                        ...formData,
                        email: value
                      })
                    }
                    email
                    emailMessage={messages['subUser_emailMessage']}
                    minLength={6}
                    minLengthMessage={`${messages['subUser_minLengthMessageEmail']} 6`}
                    maxLength={100}
                    maxLengthMessage={`${messages['subUser_maxLengthMessageEmail']} 100`}
                    required={true}
                    requiredMessage={messages['required_field']}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Form>
        </div>
      </ModalBody>

      <ModalFooter style={{ boxShadow: "2px 2px 2px 1px rgb(2 0 0 / 94%)" }}>
        <Button
          onClick={() => onClose()}
          className="btn-cancel"
          style={{ marginRight: "15px" }}
        >
          {messages["cancel"]}
        </Button>
        <Button
          className="btn-blue"
          isDisabled={!isValidEmail() || loading}
          onClick={(e) => {
            e.preventDefault();
            formRef.current.submit();
          }}
        >
          {messages[`save`]}
        </Button>
      </ModalFooter>
    </Modal>
  );

}

export default ResetEmail;